import React from "react";
import {
  Grid, Card, Button, Divider, Box, Typography, IconButton, Table, TableBody,
  TableCell, TableContainer, TableRow, Paper
} from "@mui/material";
import { Close } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Drawer from "@mui/material/Drawer";
import { formatDateTime12Hour } from "../../../helper/formatDateTime12Hour";
import colors from "assets/theme/base/colors";

const OrderDrawer = ({
  isDrawerOpen,
  isMobile,
  selectedOrder,
  handleCloseDrawer,
  handleStatusModal,
  handleDriverReminderModal
}) => {
  console.log("selectedOrder", selectedOrder);
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={handleCloseDrawer}
      sx={{
        "& .MuiDrawer-paper": {
          width: isMobile ? "90%" : "50%",
          maxWidth: 800,
          padding: "16px",
          backgroundColor: "#f5f5f5",
        },
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card>
            <MDBox mx={2} mt={1} py={2} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
              <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                <Grid item xs={12} md="auto">
                  <MDBox display="flex" alignItems="center" flexWrap="wrap" gap={2}>
                    <MDTypography variant="h6" color="white">Order Details</MDTypography>
                    <Box

                      color={`${colors.text.default}`}
                      px={2}
                      py={0.5}
                      borderRadius={1}
                      display="inline-block"
                      bgcolor={
                        selectedOrder?.current_order_status?.name === "Pending" ? "#FFA726" :
                          selectedOrder?.current_order_status?.name === "Completed" ? "#4CAF50" : "#F44336"
                      }
                    >
                      <Typography
                        variant="body2"
                        fontSize="0.875rem"
                        fontWeight="bold"
                        color="white"
                      >
                        {selectedOrder?.current_order_status?.name}
                      </Typography>
                    </Box>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md="auto">
                  <MDBox display="flex" alignItems="center" flexWrap="wrap" gap={1}>
                    {![6, 7].includes(selectedOrder?.current_status_id) && (
                      <Button
                        variant="contained"
                        color="success"
                        sx={{ color: "white", textTransform: "none", fontSize: "0.875rem", fontWeight: 500, px: 2, py: 1, minWidth: "140px" }}
                        onClick={handleStatusModal}
                      >Change Status</Button>
                    )}
                    {selectedOrder?.current_status_id === 1 && (
                      <Button
                        variant="contained"
                        color="warning"
                        sx={{ color: "white", textTransform: "none", fontSize: "0.875rem", fontWeight: 500, px: 2, py: 1, minWidth: "140px" }}
                        onClick={handleDriverReminderModal}
                      >Driver Reminder</Button>
                    )}
                    <IconButton onClick={handleCloseDrawer} sx={{ color: "white" }}><Close /></IconButton>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox p={3}>
              {selectedOrder ? (
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Card elevation={3} sx={{ p: 2 }}>
                      <MDTypography variant="h6" gutterBottom fontSize="1.125rem">Order Information</MDTypography>
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="body1" fontSize="0.875rem"><strong>Order Ref:</strong> {selectedOrder.order_ref}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Offer Count:</strong> {selectedOrder.offerCount}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Order Type:</strong> {selectedOrder.order_type}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Payment Method:</strong> {selectedOrder.payment_method}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Payment Status:</strong> {selectedOrder.payment_status}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Total Amount:</strong> QAR {Number(selectedOrder.total_amount).toFixed(2)}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Commission Amount:</strong> QAR {Number(selectedOrder?.commission_amount ?? 0).toFixed(2)}({selectedOrder?.commission_rate})</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Discount Amount:</strong> QAR {Number(selectedOrder.discount_amount).toFixed(2)}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Net Amount:</strong> QAR {Number(selectedOrder.net_amount).toFixed(2)}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Order Note:</strong> {selectedOrder.note}</Typography>
                    </Card>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Card elevation={3} sx={{ p: 2 }}>
                      <MDTypography variant="h6" gutterBottom fontSize="1.125rem">Customer Details</MDTypography>
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="body1" fontSize="0.875rem"><strong>Name:</strong> {selectedOrder.user?.full_name}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Email:</strong> {selectedOrder.user?.email}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Contact:</strong> {selectedOrder.user?.contact}</Typography>
                    </Card>

                    <Card elevation={3} sx={{ p: 2, mt: 2 }}>
                      <MDTypography variant="h6" gutterBottom fontSize="1.125rem">Driver Details</MDTypography>
                      <Divider sx={{ my: 1 }} />
                      {selectedOrder.driver ? (
                        <>
                          <Typography variant="body1" fontSize="0.875rem"><strong>Name:</strong> {selectedOrder.driver.full_name}</Typography>
                          <Typography variant="body1" fontSize="0.875rem"><strong>Contact:</strong> {selectedOrder.driver.contact}</Typography>
                          <Typography variant="body1" fontSize="0.875rem"><strong>Email:</strong> {selectedOrder.driver.email}</Typography>
                        </>
                      ) : (
                        <Typography variant="body1" fontSize="0.875rem" color="textSecondary">No driver assigned.</Typography>
                      )}
                    </Card>
                  </Grid>

                  <Grid item xs={12}>
                    <Card elevation={3} sx={{ p: 2 }}>
                      <MDTypography variant="h6" gutterBottom fontSize="1.125rem">Service Details</MDTypography>
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="body1" fontSize="0.875rem"><strong>Category:</strong> {selectedOrder.category?.name_en}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Service Type:</strong> {selectedOrder.service_type?.name_en}</Typography>
                      <Typography variant="body1" fontSize="0.875rem" sx={{ wordBreak: "break-word" }}><strong>Pickup Address:</strong> {selectedOrder.pickup_address}</Typography>
                      <Typography variant="body1" fontSize="0.875rem" sx={{ wordBreak: "break-word" }}><strong>Dropoff Address:</strong> {selectedOrder.dropoff_address}</Typography>
                      <Typography variant="body1" fontSize="0.875rem"><strong>Distance:</strong> {selectedOrder.distance} km</Typography>
                    </Card>
                  </Grid>

                  {selectedOrder?.offers && selectedOrder.offers.length > 0 && (
                    <Grid item xs={12}>
                      <Card elevation={3} sx={{ p: 2 }}>
                        <MDTypography variant="h6" gutterBottom fontSize="1.125rem">
                          Offers
                        </MDTypography>
                        <Divider sx={{ my: 1 }} />
                        <TableContainer
                          component={Paper}
                          sx={{
                            boxShadow: "none",
                            border: "none",
                          }}
                        >
                          <Table>
                            <TableBody>
                              <TableRow>
                                <TableCell><strong>Driver</strong></TableCell>
                                <TableCell><strong>Contact</strong></TableCell>
                                <TableCell><strong>Amount</strong></TableCell>
                              </TableRow>

                              {selectedOrder.offers.map((item) => (
                                <TableRow key={item.id}>
                                  <TableCell>{item.user?.full_name}</TableCell>
                                  <TableCell>{item.user?.contact}</TableCell>
                                  <TableCell>QAR {item.amount}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </Grid>
                  )}


                  {selectedOrder?.details && selectedOrder.details.length > 0 && (
                    <Grid item xs={12}>
                      <Card elevation={3} sx={{ p: 2 }}>
                        <MDTypography variant="h6" gutterBottom fontSize="1.125rem">
                          Order Items
                        </MDTypography>
                        <Divider sx={{ my: 1 }} />

                        <TableContainer
                          component={Paper}
                          sx={{
                            boxShadow: "none",
                            border: "none",
                          }}
                        >
                          <Table>
                            <TableBody>
                              <TableRow>
                                <TableCell><strong>Service</strong></TableCell>
                                <TableCell><strong>Value</strong></TableCell>
                                <TableCell><strong>Price</strong></TableCell>
                              </TableRow>

                              {selectedOrder.details.map((item) => (
                                <TableRow key={item.id}>
                                  <TableCell>{item?.order_option?.name_en}</TableCell>
                                  <TableCell>{item.value}</TableCell>
                                  <TableCell>QAR {item?.order_option?.price}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </Grid>
                  )}


                  <Grid item xs={12}>
                    <Card elevation={3} sx={{ p: 2 }}>
                      <MDTypography variant="h6" gutterBottom fontSize="1.125rem">Tracking History</MDTypography>
                      <Divider sx={{ my: 1 }} />
                      <MDBox>
                        {selectedOrder.trackings?.map((tracking) => (
                          <MDBox key={tracking.id} mb={2} p={2} bgcolor="grey.100" borderRadius="md">
                            <Typography variant="body1" fontSize="0.875rem"><strong>Status:</strong> {tracking.order_status?.name}</Typography>
                            <Typography variant="body1" fontSize="0.875rem"><strong>Description:</strong> {tracking.description}</Typography>
                            <Typography variant="body1" fontSize="0.875rem"><strong>Date:</strong> {formatDateTime12Hour(tracking.createdAt)}
                            </Typography>
                          </MDBox>
                        ))}
                      </MDBox>
                    </Card>
                  </Grid>
                </Grid>
              ) : (
                <Typography variant="body1" fontSize="0.875rem" color="textSecondary">No order details available.</Typography>
              )}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default OrderDrawer;